import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';
import Plyr from 'plyr-react';

import 'plyr-react/dist/plyr.css';
import '../../styles/plyr-react.css';

import OEToolbox from '../../lib/tools/oe-toolbox';

/*
The primary purpose for this coating of the Plyr component is to prevent unnecessary DOM reinsertions through state caching,
which is necessary for fullscreen mode working reliably.
So if you change the state management of OEPlyr please check that fullscreen mode is still working afterwars.
*/
export default class OEPlyr extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            source: this.createSource(),
            options: this.createOptions()
        };

        this.onRef = this.onRef.bind(this);
    }
    
    createOptions(props) {
        props = props || this.props;
        return {
            debug: props.debug,
            controls: clone(props.controls),
            ratio: props.ratio
        };
    }

    createSource(props) {
        props = props || this.props;
        return {
            type: props.type,
            sources: [{src: props.src, provider: props.provider}]
        };
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.type !== this.props.type || nextProps.provider !== this.props.provider ||nextProps.src !== this.props.src) {
            this.setState({source: this.createSource(nextProps)});
        }

        if(!OEToolbox.shallowEqual(nextProps.controls, this.props.controls, true) || nextProps.debug != this.props.debug || nextProps.ratio != this.props.ratio) {
            this.setState({options: this.createOptions(nextProps)});
        }
    }

    play()  {
        return this.plyrRef && this.plyrRef.play ? this.plyrRef.play() : undefined;
    }

    pause() {
        if(this.plyrRef && this.plyrRef.pause)   this.plyrRef.pause();
    }

    togglePlay(toggle)  {
        return this.plyrRef && this.plyrRef.togglePlay ? this.plyrRef.togglePlay(toggle) : undefined;
    }

    stop() {
        if(this.plyrRef && this.plyrRef.stop)   this.plyrRef.stop();
    }

    restart() {
        if(this.plyrRef && this.plyrRef.restart)   this.plyrRef.restart();
    }

    onRef(ref)  {
        this.plyrRef = ref ? ref.plyr : undefined;
    }

    render() {
        return (
            <div 
                className={'oe-plyr ' + this.props.className}
                style={this.props.style}
            >
                <Plyr
                    style={this.props.style}
                    source={this.state.source}
                    options={this.state.options}
                    ref={this.onRef}
                />
            </div>
        );
    }
}

OEPlyr.defaultProps = {
    className: '',
    type: 'video',
    provider: 'youtube',
    controls: ['play-large', 'play', 'progress', 'current-time', 'captions', 'fullscreen'],
    debug: false
};

OEPlyr.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    type: PropTypes.string,
    provider: PropTypes.string,
    src: PropTypes.string,
    controls: PropTypes.arrayOf(PropTypes.string),
    ratio: PropTypes.string,
    debug: PropTypes.bool
};